var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"font-bold",class:_vm.classNames,attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.icoCirclePlus,"alt":"","width":"24"}}),(_vm.title && !_vm.onlyIcon)?_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }